import { create } from 'zustand';

interface LockSearchFormStore {
  isLocked: boolean;
  message: string | null;
  setIsLocked: (val: boolean, message?: string) => void;
  setMessage: (message: string | null) => void;
  resetIsLocked: () => void;
}

export const useLockSearchFormStore = create<LockSearchFormStore>((set) => ({
  isLocked: false,
  message: null,

  setIsLocked: (val: boolean, message?: string) =>
    set({
      isLocked: val,
      message: message ?? null
    }),

  setMessage: (message: string | null) => set({ message }),

  resetIsLocked: () =>
    set({
      isLocked: false,
      message: null
    })
}));
